import { computeColumnStats, computeColumnStatsAsync, TYPES } from './fieldStats.js';
import { classifyField, groupColumns, GROUPS } from './semanticGrouper.js';

function assemble(stats, options) {
  const groups = groupColumns(stats.columns);
  const overrides = options.groupOverrides || {};
  const columns = stats.columns.map((col) => ({
    ...col,
    semanticGroup: overrides[col.name] || classifyField(col.name, col.detectedType),
  }));
  return {
    totalRecords: stats.totalRecords,
    totalFields: stats.totalFields,
    typeBreakdown: stats.typeBreakdown,
    groups,
    columns,
  };
}

export function auditDataset({ headers, rows }, options = {}) {
  return assemble(computeColumnStats(headers, rows), options);
}

// Variant asíncrona troçejada amb progrés (no bloqueja el navegador en fitxers grans).
// onProgress rep { phase, processed, total }: 'fields' durant l'anàlisi de columnes i
// 'grouping' a l'agrupació final. Resultat idèntic a auditDataset.
export async function auditDatasetAsync({ headers, rows }, options = {}, onProgress = () => {}) {
  const stats = await computeColumnStatsAsync(headers, rows, onProgress);
  onProgress({ phase: 'grouping' });
  return assemble(stats, options);
}

export { TYPES, GROUPS };
